import { pipe } from 'ramda';
import Http from '../../../http';
import { SET_BREAKDOWN } from './constants';
import { mapServiceBreakdown, mapBarberBreakdown } from './helpers';
import * as barberSelectors from '../../barbers/selector';

const setBreakdown = items => ({
  type: SET_BREAKDOWN,
  payload: items,
});

export const setServiceBreakdown = pipe(
  mapServiceBreakdown,
  setBreakdown,
);

export const setProductBreakdown = pipe(
  mapServiceBreakdown,
  setBreakdown,
);

export const setBarberBreakdown = allBarbers => pipe(
  mapBarberBreakdown(allBarbers),
  setBreakdown,
);

export const clearBreakdown = () => setBreakdown();

export const fetchBreakdown = (shopId, from, to, barbers) => (dispatch, getState) => {
  const filters = {
    includeBreakdown: true,
    barberFilter: barbers,
  };
  const allBarbers = barberSelectors.getAll(getState());
  return Http.get(`/shop/${shopId}/report/barber/${from}/${to}`, filters)
    .then(response => dispatch(setServiceBreakdown(allBarbers)(response.breakdown)));
};
